/*
 * @Description: 
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2023-08-16 16:03:26
 * @LastEditors: changfeng
 * @LastEditTime: 2024-01-15 10:57:49
 */
export default (initialState: API.UserInfo) => {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // 参考文档 https://umijs.org/docs/max/access

  const superAdmin = (
    initialState && initialState?.currentUser?.roles?.includes('admin')
  );
  const hasAnalyzeRole = (
    initialState && initialState?.currentUser?.roles?.includes('analyze') || initialState && initialState?.currentUser?.roles?.includes('admin')
  );

  const currentUser = (initialState as any)?.currentUser;
  const customerCategories = Array.from(new Set(
    (Array.isArray(currentUser?.customerCategory)
      ? currentUser.customerCategory
      : String(currentUser?.customerCategory ?? '').split(','))
      .map(Number)
      .filter((item) => item === 1 || item === 2),
  ));
  const isAffiliateOnly =
    !superAdmin && customerCategories.includes(2) && !customerCategories.includes(1);
  // 包含 Affiliate 即开放卡台；仅 Affiliate 使用精简菜单，双选展示两类菜单的并集。
  const canViewCardDesk =
    String(currentUser?.bcType || '').toLowerCase() === 'gnh' &&
    customerCategories.includes(2);
  const canViewStandardCustomerMenus = !isAffiliateOnly;
  const Analyze = hasAnalyzeRole && !isAffiliateOnly;

  console.log("superAdmin",superAdmin,'Analyze',Analyze,'canViewCardDesk',canViewCardDesk)
  return {
    superAdmin,
    Analyze,
    canViewCardDesk,
    canViewStandardCustomerMenus,
  };
};
